module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/004TOC#chapter_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ONE")])])])]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GROWING UP PSYCHIC")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I")])]), _vm._v(" believe that before we come here from the Other Side to start a new incarnation, we write very detailed charts for our lifetimes to help guarantee that we accomplish the goals we set for ourselves. We choose our parents, our siblings, our friends, our enemies, our spouses, our children, our careers, our assets, our challenges, our health issues, our best and worst qualities, the best and worst qualities in those who are closest to us, and certainly the timing of it all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As I look back on this long, strange, complicated life I’ve lived, I just have one question about the chart I wrote:")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What the hell was I thinking?")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("T’S")]), _vm._v(" V"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ALENTINE’S")]), _vm._v(" D"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AY")])]), _vm._v(" 2009. I’m seventy-two years old. I’m blind in one eye, and I have a limp from an irreparable crack in my femur (a lasting token of my first husband’s esteem). I’m standing at the head of an aisle in an ivory silk dress, holding a bouquet, surrounded by a room full of family, friends, and my Novus Spiritus ministers. Smiling confidently back at me from beneath the arch at the end of the aisle is a tall, handsome, sixty-two-year-old man named Michael Ulery. In the year we’ve been together he’s seen me at my best and "), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("my worst, and he’s been nothing but kind, supportive, patient, hard working, and thoughtful. He’s so good natured and in such a perpetually good mood that I frequently stare at him, especially first thing in the morning when he brings me coffee without my asking, and say, “What’s wrong with you?”")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Michael is a successful jewelry designer and businessman. I first saw him in a jewelry store near my office in Campbell, California, at a time in my life when my position on relationships was a firm, nonnegotiable, “Spare me.” So you could have knocked me over with a feather when I found myself asking the store owner about the attractive man behind the counter who was busy helping another customer. On our first date a week or so later he apologetically admitted that when we were introduced he didn’t have the first clue who I was. Just when I thought he couldn’t be more perfect. And the rest, as they say, is history.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So here I am, limping down the aisle into marriage number four (or number five, but only on a technicality), impossibly happy but also chagrined at the fact that obviously, when I was on the Other Side writing my chart, it seemed like a great idea to wait until I was in my seventies to meet the real Mr. Right. I repeat—what the hell was I thinking?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then again, if it took this long, and this much, to get to this moment, I might write that same chart all over again.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("O GET THE")])]), _vm._v(" requisite details out of the way: I was born Sylvia Celeste Shoemaker in Kansas City, Missouri, on October 19, 1936.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("My father Bill and I adored each other from the moment we first laid eyes on each other. He was a good-looking, funny, warm, affectionate extrovert who made me feel like the most important person in the world when he’d wink at me and say, “That’s my girl.” He was a postman who exercised his love of show business by emceeing all ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("sorts of local events, and even in the worst of times we could make each other laugh until we cried.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And then there was my mother. Celeste. As mean, self-involved, humorless, and disconnected a woman as you’d ever hope to meet. She was physically abusive when my father wasn’t around, and she delighted in telling me about lying awake at night trying to figure out how she could kill me and get away with it. Her way of dealing with situations that displeased her was to retire to her bathtub and soak herself into pretending they didn’t exist, which is probably why I remember her as being prune-y most of the time. My father had several affairs throughout his marriage to my mother, and I didn’t blame him. In fact, I always believed that the only reason he never left her is that he would have had to kiss her good-bye.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’ve come to know that there are people in this world called “dark entities.” Dark entities are those who, because they’ve turned away from God and abandoned His light, choose to spread nothing but darkness in their lives. By their own choice, when they die, their spirits don’t transcend to the sacred perfection of the Other Side. Instead, they enter what’s known as the Left Door, plunge through a Godless, joyless abyss, and cycle right back into some poor unsuspecting fetus again. If one of these days you read about someone in their late teens triggering a violent uprising in some historically peaceful country, you can confidently say to yourself, “Oh, look, it’s Sylvia’s mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It seems important to add that I took care of my mother in the last years of her life. My Gnostic Christian beliefs demanded nothing less, and beliefs without the actions to back them up are nothing but rhetoric. I admit it: I did it more for my own peace of mind and my certainty that it was just plain the right thing to do than out of any delusion that she would have done the same for me.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("My very earliest childhood memories involve my enraged mother chasing me through the hallway waving a wire hanger she intended ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("to beat me with (after seeing the movie "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mommie Dearest")]), _vm._v(" I wondered if my mother might have been the technical consultant); standing in my crib peering out the window, watching anxiously for Daddy’s black car to pull into the driveway so I’d be safe from her for awhile; and the incident I’ve come to think of as The Time She Tried to Burn My Foot Off.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was three years old. It was bath time. What I distinctly remember is Mother putting me into the tub, turning on a full blast of scalding hot water and leaving the room. My foot had to be treated for second-degree burns. Much of the aftermath is a little hazy. There was something about Mother explaining to Daddy that she’d had to leave me alone to answer the phone (take it from me, there was no phone call) and that she’d warned that damned building maintenance man a thousand times to stop cranking up the temperature of the water heater. And there was a loud conversation behind the closed door of my mother’s bedroom between her and an aunt and uncle who threatened to take me to live with them if there was ever another hint of abuse, no matter how “accidental” she claimed it was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That threat made Mother much more circumspect about hurting me—it never occurred to her to stop, but from then on she saw to it that there were never potential witnesses or visible marks. Not for a moment did her occasional, unpredictable bursts of rage inspire me to be more well behaved. They just inspired me to be faster, smarter, and angrier at her, until finally, when I was about seven, I ratted her out to Daddy. I can still hear his voice, and feel my heart bursting with love and gratitude for my brave, strong hero, as he turned to her and promised with quiet fury, “I’ve never raised my hand to a woman in my life, but if you ever touch that child in anger again, I will tear you apart.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I believed him. Clearly, so did she. She never physically hurt me again. Emotionally? Keep reading.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("D"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ISPELLING MUCH OF")])]), _vm._v(" my mother’s darkness throughout my childhood was the warm, loving flame of her mother, my grandmother Ada Coil. She was my inspiration, my mentor, my fearless defender, and the quiet sanctuary where my lifelong devotion to God had its roots. Without Grandma Ada, my life would have made no sense to me at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grandma Ada was brilliantly psychic, another link in a three-hundred-year psychic family legacy. I was the next link in that legacy, complete with a caul, or fetal membrane, wrapped around my head at birth, thought to be the sign of a child born with “the gift.” Grandma Ada didn’t tell me about the caul or its significance for several years, to avoid programming me for expectations that might never manifest. Instead she just watched and waited, loving me unconditionally, confident that if I really had inherited her psychic gift, there would be no stopping it, and no stopping me from expressing it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was right.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HAVE NO")])]), _vm._v(" memory of two psychic incidents that happened when I was three years old. But I’m told I informed my parents that I would have a baby sister when I was six (my only sibling, Sharon, was born a month before my sixth birthday). And I announced, “Grandpa’s dead,” moments before Daddy arrived home one sad afternoon to break the news that his father had just passed away from a sudden heart attack.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Instead, my memory flashes from those days are limited to things that really mattered, like riding my beloved tricycle and being enchanted by fireflies and learning that roller skates worked much better on the sidewalk than they did on our grassy front yard. Doing my dolls’ hair, or hostessing tea parties for my stuffed animals? ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("When I could be outside playing “ditch ’em” with the other kids in the neighborhood? Not a chance, thanks. (In case you’re not familiar with ditch ’em, just think hide and seek after dark with flashlights.)")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In fact, with the exception of Mother’s intermittent volatility, my early childhood was so ordinary that it made my first genuine psychic experience feel like a horrible ambush. I was five years old, pushing vegetables around on my plate at a boring Sunday family dinner, when I happened to glance over at my great-grandmother Hattie Braun. In less than a second her face went from perfectly normal to hideous, melting like hot wax down onto her neck, exposing her skull, nothing but gaping cavities where her eyes, nose, and mouth used to be. I froze, terrified, while she and everyone else at the table went right on idly eating and chatting away as if nothing unusual was happening. Finally I managed to tear my focus away from her and turned for comfort to my other great-grandmother Sarah Shoemaker, who was sitting next to me, which drove me to sheer panic when I saw that her face was melting too, just like Hattie’s.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I leapt up from the table and ran to my father, grabbing his arm and begging him to take me home. I was hysterical, and I’m sure everyone was both worried and relieved when he made a quick, apologetic exit, carried me outside, and asked me what was wrong. Needless to say, it was no help when all I could do was repeat over and over again through my tears, “Their faces were melting! Their faces were melting!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Great-Grandmother Hattie and Great-Grandmother Sarah passed away within the next two weeks, just four days apart, and with a typical child’s logic of believing that everything that goes wrong is her fault, I was sure that somehow, thanks to those grotesque visions, I’d killed them. Shaken by the trauma, the isolation of my parents’ inability to understand what I was talking about, and the guilt of thinking I’d personally ended two sweet, harmless lives, I became a depressed, withdrawn, deeply troubled little girl.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For the first of more times than I can count, Grandma Ada reached her strong hand into my confusion and pulled me out. She arrived at our house one day not long after my great-grandmothers’ deaths, recognized that something was very wrong with her cherished granddaughter, gently took me into her lap and said, “Whatever it is, you can tell me, my sweetheart.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I burst into tears and sobbed my way through the story of the melting faces no one else saw and the two resulting murders I’d clearly committed. Instead of staring at me as if I’d just grown antennae, she held me closer and said, “First of all, I promise, you didn’t do one thing to Hattie and Sarah. They just finished their time here, and their bodies were old and tired, so they asked God to bring them Home. They’re happy and healthy now, living in heaven with Jesus and the saints and all the Angels, and it didn’t have a single thing to do with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It made me feel a little better, and I asked if she was sure. She nodded and wiped away my tears before she added, “Second of all, I’m sorry for what you saw that night at dinner. It must have been very scary.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You mean, you believe me, Grandma?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course I believe you,” she assured me. “I know exactly what it’s like to see things that other people don’t see, and I know exactly how alone it can make you feel. But it’s nothing to be frightened about, sweetheart; it’s because God gave us a gift that we’ll have with us all our lives. You and I are something called ‘psychic.’”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A gift? Was she kidding? “No! I don’t want to be psychic!” I protested through a new wave of tears. “It’s ugly, and I hate it, and I don’t want to see melting faces for the rest of my life!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then here’s what we’ll do,” she said. “We’ll just ask God to never show you anything ever again that’s too scary or upsetting for you to handle.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Before I could argue, she closed her eyes and began to pray. I prayed with her, and kept right on praying, and while I could fill ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("libraries with books on the psychic visions I’ve had since then, I’ve never been given another one that was more emotionally challenging than I could take.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Looking back, it’s extraordinary how significant that afternoon was in the course of my life. It gave me a very special connection to a woman I deeply loved, trusted, and admired. It gave me permission to embrace rather than apologize for what had happened to me because it came from God. It gave me a word—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("psychic")]), _vm._v("—to call what had happened, which made it seem a little safer and less freakish. And although I wasn’t sure I understood or even quite believed this part yet, Grandma Ada, who never lied to me, said it was a gift, so I could at least try to figure out what it was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Almost immediately I began noticing that every night after I turned off my nightstand lamp, my bedroom began filling with spirits. None of them seemed interested in me; they just milled around among themselves like opaque shadows. To this day I’m not sure if I was becoming more finely tuned to the higher frequency of the Other Side or if my reluctant acceptance of being psychic attracted them to someone they knew would be able to see them, in a kind of “Party in Sylvia’s room!” celebration. What I am sure of is that while I never believed they meant me any harm, I found it unnerving to try to go to sleep with a semi-transparent crowd floating around the bed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I mentioned it to my mother, who immediately began drawing a hot bath for herself. I mentioned it to my father, who had long since become accustomed to having a psychic mother-in-law but didn’t have a clue what to say or do about it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("I mentioned it to Grandma Ada, who’d had the same problem since she was a child, and she calmly handed me a flashlight to take to bed with me. (I still can’t sleep in a completely dark room, by the way. And if your children tell you they’re upset by spirits visiting them during the night, don’t tell them they’re imagining things. ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("They’re not. Just assure them the spirits would never hurt them and give them a flashlight.)")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Before long spirits began appearing any time, anywhere, and one incident taught me two interesting lessons: that visions differ from one psychic to the next, and that psychics aren’t psychic about themselves. (For more proof of that second lesson, read the rest of this book.) One day Grandma Ada and I were tearing the house apart looking for a steel strongbox that contained some papers she urgently needed. When we got around to her bedroom, I saw Great Grandmother Hattie, Ada’s deceased mother, materialize and point to the back of a massive dresser. I shared this news with Grandma Ada, who hadn’t seen a thing, and it triggered her memory of hiding the strongbox behind the dresser where no one (including her, obviously) would ever think to look for it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A few nights later the family was gathered in the living room when I saw a spirit take shape behind Grandma Ada’s left shoulder. “Grandma,” I asked, “who is that man behind you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Daddy, too accustomed to this kind of thing to even glance in our direction, went right on reading. Mother rolled her eyes and made a break for the nearest bathtub. Grandma Ada asked me what he looked like.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I described him as tall, with reddish-colored hair and round wire-rimmed glasses, and I added, “There’s a string around his neck, and it has a horn on it that he uses to listen to people’s chests.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s my Uncle Jim!” she gasped, more thrilled than I’d ever seen her. He’d been her favorite uncle, a doctor who’d died twenty-four years earlier in a flu epidemic, and she gave me an ecstatic hug to thank me for letting her know that this man she’d missed so much was around her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So there really was an up side to this psychic thing. Who knew?")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("ROM THAT NIGHT")])]), _vm._v(" on, it was as if floodgates had opened. I routinely saw spirits around almost everyone. I knew who was calling or coming to visit before the phone or doorbell rang. I guilelessly asked Daddy, in front of my mother, who the nice blonde lady was he was going to visit when he made some excuse to leave the house for the evening. I warned even the most casual passersby that there was something wrong with their liver or their gall bladder or their spleen before I even knew what livers, gall bladders, and spleens were. I can only imagine how relieved my family was when the time came for me to start school.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My Jewish father, my Episcopalian mother, and my Lutheran grandmother were united in their belief that I was in serious need of some structure, strong guidance, and constructive focus. They weren’t wrong. I hadn’t learned yet how to control the images that surrounded me or how to separate myself from the psychic impact of the emotional and physical force fields everyone unconsciously gives off. I could easily become exhausted, depressed, anxious, or even physically ill in large groups of people from sheer extrasensory overload, depending on the moods and/or health problems of anyone in my involuntary radar. I still loved being with my neighborhood playmates, but I was beginning to feel isolated since none of them seemed to see what I saw, sense what I sensed, or know what I knew. From what I’d heard about school, there would be new things to learn and be stimulated by and a whole new group of children to make friends with, and I couldn’t wait.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Somehow the Lutheran in the family came up with the idea that the perfect answer to my need for structure, guidance, and grounding would be a convent. Even more remarkably, the Jew and the Episcopalian agreed with her. In what seemed like the blink of an eye, Grandma Ada, Daddy, Mother, and I were all taking instruction in Catholicism and being baptized together in the church, and my formal education was placed in the firm, steady hands of nuns.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I loved school. I loved learning. I loved being surrounded by friends my own age who playfully lured me outside of my own head for hours at a time. And I especially loved the nuns. I was in awe of their dedication and commitment and the fact that they knew God and Jesus and the Angels personally. I began wearing black around the house with a white hand towel draped across my chest, an improvised homage to the nuns’ habits, and I announced to anyone who’d listen that I was going to be a nun when I grew up. (Pause for exhales of relief from Catholics around the world that I clearly changed my mind.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My sister Sharon came along shortly after I started school. She was born without a caul and without an apparent psychic bone in her body, although I’ll always believe that everyone has psychic abilities, whether they put them to active use or not. In other words, from the beginning Sharon was something I yearned to be but couldn’t accomplish for the life of me: she was “normal” without just pretending to be. According to our mother, that wasn’t the only difference between us. She must have said a thousand times, to us and to everyone else, “Sharon’s the pretty one, and Sylvia’s the one with the personality.” On the slim chance that she intended it as a compliment, neither of us ever heard it that way. Instead what we heard was, “Sylvia’s ugly, and Sharon has the personality of a flounder.” I’m sure the carefully cultivated sibling rivalry between us, along with our six-year age difference and the fact that we were simply two very different people kept us from ever being best friends, but we were closely involved in each other’s lives.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("And there’s no doubt that I was psychically tuned in to her. Daddy and I had begun the tradition of spending Saturdays together, just the two of us, doing some kind of activity—roller skating at the local rink, fishing, paddle boating, or our favorite pastime, going to movies, usually preceded by an hour at the newsstand browsing through "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Photoplay")]), _vm._v(" and every other movie magazine we ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("loved. One day, during a matinee of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stage Door Canteen")]), _vm._v(", which we were thoroughly enjoying, I found myself feeling dizzy and gasping for air. I panicked, wondering if maybe I was dying, until I realized that I was fine; it was my baby sister who was in trouble. I grabbed Daddy’s arm and began frantically pulling him out of his seat toward the exit. He understandably resisted until I screamed, “It’s Sharon! She can’t breathe! We have to go right now!” He was at a dead run right behind me by the time we reached our car, and as we pulled into our driveway my mother raced out of the house sobbing that Sharon couldn’t breathe and was turning blue and our phone wasn’t working. Daddy sped off to the hospital with Sharon, who had contracted double pneumonia and arrived at the emergency room with only minutes to spare.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In other words, I was still “knowing” things without a clue how I knew them and still seeing spirits day and night. But school, friends, the wise, all-knowing nuns, and endless worlds to explore thanks to my newly acquired skills of reading and writing (don’t get me started on ’rithmetic) were making me feel more balanced and more grounded. I found myself wondering if maybe, at the risk of sounding like an ingrate, this “gift” from God would gradually fade away and I could finally just be a little girl who’d ask, “Did you see that?” and everyone around me would say, “Yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("NY HOPE OF")])]), _vm._v(" the gift fading away vanished one night when I was eight years old, a night that would dramatically affect the rest of my life. I was in bed, under strict orders to go straight to sleep, so of course I was playing with my flashlight, beaming it around the room as the usual opaque shadows of spirits silently gathered to mingle. With no warning, the beam of light began to grow and intensify into an almost blinding white-gold glow, and while I gaped at it in awe a ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("woman’s voice resonated from deep inside it, in a rapid, unearthly chirp. “Don’t be afraid, Sylvia,” the voice said. “I come from God.”")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At that moment I didn’t care if the voice came from God or Albuquerque, I was out of there, flying out the door in absolute terror and racing down the stairs to the kitchen, where Grandma Ada was cleaning vegetables from her Victory Garden. I slammed into her and held on for dear life, sobbing through the story of what had just happened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That was your Spirit Guide, dear,” she explained calmly, stroking my hair. “Pick up the carrots.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A Spirit Guide, it turns out, is someone who, when we decide to come to earth for another incarnation, agrees to be our vigilant companion and helpmate while we’re away from Home. They’ve studied our charts and know what we intend to accomplish here, and it’s their assignment to encourage, support, and advise us along the way without interfering with our charts or depriving us of our free will.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("As I’ve learned over all these decades, their messages to us are so typically subtle, and spoken so directly to our subconscious minds where our spirits live, that it’s easy to mistake them for our own instincts, or a “sudden impulse” or the ever-popular “Something told me to….” An instinct prompts us to change dinner reservations at the last minute from one restaurant to another, and we run into someone at that second restaurant whom we needed to see, whether the reason we needed to see them is immediately apparent or not. We take a different route than usual when heading to work one morning on a “sudden impulse” and discover later that, by doing so, we avoided an accident. “Something tells us to” call a friend we haven’t talked to in awhile and, it turns out, she has the solution to a problem we’ve been worried about or helpful information we didn’t even anticipate needing. In fact, as a good rule of thumb, every time you write off an impulse with the words “Something told me to…” change that to “Some"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("one")]), _vm._v(" told me to…” and chances are you’ll ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("be much more accurate. A Spirit Guide isn’t Batman or Wonder Woman. Our Guides aren’t with us to ride to our rescue whenever we’re in trouble. They’re with us to support us through the trouble we charted for ourselves and gently see to it that, according to our own plans for this lifetime, we’re where we’re supposed to be when we’re supposed to be there, doing what we need to do, for better or worse, to study the lessons we’ve chosen to come here to learn.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Grandma Ada seemed impressed that in addition to being clairvoyant, or able to see beings and objects that originate in another dimension, I had now become clairaudient, or able to hear them, as well. I loved impressing her and tried to smile, but privately I was thinking, “Just shoot me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not for the first or last time, I couldn’t have been more wrong. My Spirit Guide’s voice has been a constant, invaluable presence in my life, and in the lives of others, since the night she introduced herself in my bedroom. She lived her one incarnation on earth as an Aztec-Incan who, at the age of nineteen, was killed by a spear in 1520 while protecting her infant daughter during the Spanish invasion of Colombia. She told me her name was Ilena. I apparently either didn’t care for that or couldn’t remember it, because I promptly renamed her Francine and have never called her anything else. She’s never objected, which is a good lesson for all of you who have no idea what your Spirit Guide’s name might be: they couldn’t be less concerned with what we call them, they’re only concerned "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" we call them.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("F"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("OR THE RECORD")]), _vm._v(",")]), _vm._v(" by the way, I didn’t actually see Francine that first night. While many others have seen her over all these decades, I only had one quick glimpse of her, during a meltdown in my late teens, and I deliberately looked away before she’d fully materialized. But that’s another story for later in this chapter.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Communicating with Francine became a daily routine, although it took me awhile to get accustomed to her voice. Like every other spirit I’ve talked to, she lives on the Other Side, our real Home, from where we all came and to where we’ll all return, which exists on a much higher frequency than ours on earth. The result is that spirit voices sound very much like a tape played on fast forward or, for those of you who are old enough to remember, Alvin of Chipmunk fame. I learned quickly to understand her, though, and to appreciate her as yet another fascinating source of new information, no less interesting than school continued to be.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So imagine my delight one day in class when one of the nuns decided to teach us that while our bodies inevitably die, our spirits survive death. Eager to validate this reassuring bit of news, I chimed in that I happened to know that was true, because I saw and talked to spirits all the time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now, imagine my utter shock when I found myself on the receiving end of a tirade from an enraged nun. She was appalled that I would commit such heresy in her classroom by making up such an outrageous lie, and I’d be staying after school to give me a little extra time to get my fresh mouth under control.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I didn’t understand it then, and I don’t understand it now: it makes sense to almost every religion on earth that our spirits survive death, but it’s sacrilege to believe we can communicate with them? What possible sense does "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" make? And how could it possibly be sacrilege, when I knew I loved God every bit as much as any nun in that convent? Maybe even more to the point, accusing me of making up a reality I’d been living since I was four years old confused me as much as if I’d been accused of making up my parents.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("I was beside myself when I got home from school that day. But not nearly as beside myself as Grandma Ada was when I explained to her why I was so late. After assuring me that I’d done nothing wrong, she grabbed her handbag and marched off to school, where ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("she and the nun had “a talk.” That’s all she told me, but I would love to have been a fly on the wall—that nun never again accused me of making things up or punished me for sincerely trying to contribute to a discussion. Of course, I was also thought of as a bit of a troublemaker from then on, but because the faculty knew I genuinely admired them and meant no disrespect when I did speak up, we got along beautifully for the most part.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("GOT AN")])]), _vm._v(" extraordinary education over the next several years, although some of it continued to confuse me. From what the Catholics told me, we are all created by an all-knowing, all-loving, perfect God who adores us unconditionally—unless we commit mortal sins like not going to confession, not being Catholic, getting divorced, using birth control, or eating meat on Fridays, in which case He’ll smite us and send us to burn in the fires of hell for the rest of all eternity. (Huh? And by the way, in recent years the church has decided that it’s okay for the Catholics to eat meat on Fridays after all. So what happens to those poor people who were sent to hell for that? Do they get transferred to heaven now, or what?) If we obeyed all His rules, we would go to heaven when we died, and then…uh…. (They were a little hazy about what heaven looks like or what we do with ourselves when we get there.) God promised us eternal lives, but these lives we’re living now are the first ones we’ve ever had. (So where have we been for all these eons since time began?)")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("And then there was confession, which completely mystified me. I went to my first confession when I was eleven, and because even at that age I was a chronic overachiever, I had my heart set on being thorough and well prepared to impress the priest with what a devout little Catholic I was. Days ahead of time I began writing down all the sins I wanted to confess to: talking back to my mother, telling my sister she had cooties even though she probably didn’t (I was ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("never quite sure what cooties were, I just knew Sharon didn’t seem to want them), telling my parents I brushed my teeth twice one day when I only brushed them once…. It seemed like a pretty lame list for my first confession, so I made up a few other infractions of equal gravity, reverently took my seat in the confessional, and began in a trembling little voice, “Forgive me, Father, for I have sinned.”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was only on about my third “sin” when the priest heard me shuffling my paperwork and asked what I was doing. Rather than praising me for my diligence in preparing a list, he gave me a very indignant scolding. What if I’d misplaced my list and someone had come across it, he demanded? How could I be so careless and risk exposure like that? Imagine the shame if it found its way into the wrong hands?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Granted, I was only eleven. But I was old enough to know an over-reaction when I heard one. Shame? Was he kidding? I didn’t murder someone, I wasn’t running a prostitution ring in my neighborhood. I just mouthed off to my sister and mother and exaggerated my dental hygiene duties for one big-deal day. At worst, I wasn’t planning to do any bragging about that behavior. “Shame” never entered my mind. I managed to accept my assignment of a thousand Hail Marys or whatever it was without giving the priest a piece of my mind, but I also started wondering about the whole ritual of confession. If God loves each of us equally, as we were being taught in Catholic school, why did I need this stern, disapproving priest to atone on my behalf? Why couldn’t I just ask Him for forgiveness myself? What was the message here—that I wasn’t worthy to talk to God without an intermediary? And if that was the case, then why had I been taught to pray directly to Him with devout regularity for as long as I could remember?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("In the meantime, while I was becoming more confused than comforted by the rules and dogma of the church, Francine was chirping away about the Other Side where she lived and where the vast ma")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("jority of us live—yes, even the non-Catholics—when we’re not slogging along here on earth by our own choice for the spiritual growth of our souls. The Other Side, she told me, is a very real place, our real Home, just three feet above and identical to the earth’s surface, existing at a much higher frequency so that we don’t perceive its immediate proximity. We lead busy, active, blissful lives there among the messiahs, the Angels, our loved ones from every life we’ve ever lived on earth and at Home, and the palpable presence of God Himself. As for hell, there is no such thing, nor is there any such thing as a God so petty and vengeful that He would subject a beloved child to eternal punishment because they violated some human-made rule. God doesn’t turn His back on anyone, but there are those who turn away from Him, and they face their own self-inflicted punishment by recycling over and over again through the Left Door and back to earth for another incarnation, denying themselves the joyful peace that’s waiting for them on the Other Side.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("TOOK IN")])]), _vm._v(" all this information from the church and from Francine like the good, perpetually curious student I was. I knew which point of view made more sense to me, but beyond an absolute belief in God and Jesus, I had a lot of studying to do and questions to ask before I was ready to commit to exactly what I did and didn’t believe. And frankly, I was too busy being a psychic but otherwise normal teenager, overachieving my way through school and dealing with family drama to give it much thought.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("When I was sixteen, the chaotic rage between my parents and the new woman in my father’s life made it look as if my parents’ marriage was finally going to end. I might have been their most enthusiastic supporter if the indecision and guilt hadn’t been so horribly painful for Daddy, and if a hideous custody battle hadn’t been so inevitable. Sharon, “the pretty one,” had grown into an introverted, insecure ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("girl who was joined at the hip with our mother, so there was no question where she would go. She and I exemplified the interesting phenomenon of two siblings with the same parents and the same upbringing being polar opposites in so many ways, and Sharon was the poster child for how damaging it is to attach yourself to a dark entity. While I kept my distance from our mother and basked in the bright, positive sunshine of a father who believed there was nothing I couldn’t do, Sharon clung to a woman who virtually crippled her with negative reinforcement. “Sharon can’t do that,” Mother would say, referring to anything from simple chores to playing. “You know how frail/fragile/delicate she is.” And of course Sharon believed her and became as frail/fragile/delicate as she’d been programmed to be. Daddy and I would go laughing and stampeding down the stairs and out the door for one adventure after another, leaving Mother and Sharon in our wake, each in their separate, darkened bedrooms, Mother in her perpetual leopard print robe, somehow gratified that she’d finally been able to snare a willing, dependent hostage in this bizarre collection of people we called a family.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For obvious reasons, given a choice if and when my parents separated, I would have walked out the door with Daddy in a heartbeat, but he was in no emotional shape to offer me a stable home as a single parent. I would have ended up living with Mother and Sharon and without Daddy, which sounded like no life at all to me. To complete the feeling that the earth was crumbling away beneath my feet, Grandma Ada’s health seemed to be failing, and Francine had no better advice to offer about any of this than “It will all work out exactly as it’s meant to.” That happens to be true, but do you find it helpful when someone says it to you? Me neither. And when I was sixteen, it absolutely infuriated me.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("Then, with all the foresight and maturity of a teenager, I came up with the perfect solution: I’d get married! Yeah! That should work! Then I wouldn’t have to worry about which of my parents I was ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("going to live with—I’d live with my husband and start a life and a family of my own, and it wouldn’t matter any more whether or not Daddy and Mother stayed together.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was dating a couple of boys at the time. Joe and Warren. I decided that Joe was the likelier of the two to leap in to help me with this terrible dilemma I was in, and he’d already said that he wanted to marry me someday. He didn’t specify what he meant by “someday,” but under the circumstances, why couldn’t it mean, oh, let’s say, tomorrow?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sure enough, Joe, having exactly as much foresight and maturity as I did, thought it was a great idea. That night, after a brilliant performance of nonchalance at the family dinner table, I managed to find my birth certificate and transformed myself from a sixteen-year-old to an eighteen-year-old with a quick, artistic stroke of a pen.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After school the next day Joe and I jumped on a streetcar, went across the state line to Kansas City, Kansas, and promised in front of a justice of the peace to love, honor, and obey each other ’til death did us part, or whatever it was we repeated on cue for the five or ten minutes it took. Who listened? We were sixteen, and I’m sure the reality and stark “officialness” of what we were doing terrified Joe as much as it did me once the no-frills, sterile, assembly-line ceremony got under way. (In case you’re wondering, by the way, the bride was resplendent in a white pinafore with oh-so-fashionable white bobby sox and Oxfords.)")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("On the streetcar back to Kansas City, Missouri, we briefly discussed the possibility of a honeymoon. It was Friday, and we had a whole weekend ahead of us before school on Monday morning. The fact that neither of us had any money was trivial compared to the far bigger drawback: we weren’t planning to tell our parents about this until the time was right, whatever that meant, so the chances of their approving of a two-day honeymoon weren’t good. We ended up heading off to our respective homes an hour past curfew.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mother was in the living room, glaring angrily at the clock, when I came tiptoeing in. “Where have you been, young lady?” she demanded. “And what’s that under your dress?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I looked down at myself and saw a painfully obvious lump in my bridal pinafore. I tried, too late, to flatten it and finally, lamely answered, “Nothing. Just a, uh, license.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A license? For what? What kind of license?” She was yelling now, and I went flying up the stairs to my room, sobbing my eyes out by the time I slammed the door, horrified and remorseful and wishing to God the last few hours had never happened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mother sprinted to the bathtub while Daddy took over. He pounded at my door, demanding that I let him in. As he and the pounding grew louder and louder, my anxiety and remorse grew worse and worse, until they spilled over into enough desperation to explode, “You can’t come in! I’m a married woman now!”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Not for long. I’ll spare you the humiliating details, but Daddy may have set a record for the quickest annulment in the history of nuptial bliss, and Joe and I were forbidden by our parents from ever seeing each other again outside of school. Although he and I never talked about it, I know Joe had to be as relieved as I was.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All without missing a single day of school.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("O"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("F COURSE, NOTHING")])]), _vm._v(" had changed in the impending separation and custody issues between my parents, and while I deeply appreciated being single again, I was even more lost than before and even more eager to bury myself in my friends, activities, and school, where things at least seemed to make sense.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("It had become a source of fascination to me, as it still is today, that the more you learn, the more there is to learn. In fact, I’d become so enthralled with my studies that I abandoned the idea of becoming a nun and decided Grandma Ada was right: I was meant ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("to be a teacher. I loved everything about English, creative writing, and poetry. I loved typing and shorthand. I loved almost everything about home ec—I excelled at cooking and needlepoint, but sewing and I held each other in mutual contempt from the moment we met.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I took tap and ballet lessons, the “lesson” in this case being that I should never be allowed anywhere near tap or ballet shoes again in this lifetime. In sharp contrast, Daddy and I began taking ballroom dance lessons as one of our traditional Saturday activities, entered a few local contests and won them, mind you, which more than made up for my lack of a future as the lead Sugar Plum Fairy in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Nutcracker")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I developed my first real crush. His name was Mario Lanza, and he starred in a movie called "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Great Caruso")]), _vm._v(", which I must have seen a million times (or, okay, maybe twelve). I bought all his records and sang along with them at the top of my lungs in perfect phonetic Italian until everyone within earshot begged me to stop. Sadly, my passion was unrequited. I blame the fact that we never actually met.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And I was blessed with lots of friends, partly because I was an extrovert and made a point of being a good friend myself, and partly because, as my friend Mary Margaret had put it since kindergarten, when I accurately told her that her mother’s arm would be broken and her father would lose his job, I “knew things.” I don’t think a week went by without a classmate or even one of the nuns pulling me aside to ask for some kind of psychic insight. Mary Margaret came to believe that I could be lying under a bus, bloody and barely breathing, and as my friends pulled me to safety they’d be pelting me with questions in case I didn’t make it—“Is my boyfriend cheating on me?” and “Is Bobby going to invite me to the prom?” and “Am I going to pass my chemistry final next week?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("Two incidents in particular are as clear in my memory as if they happened earlier this week. In one I “saw” my friend Joan fracturing her skull on the dashboard of a blue car, and I begged her to stay ")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("out of blue cars for awhile. Before long she was heading off to run errands with a family friend and she saw that her friend was driving a blue car. She remembered my warning and stayed home. A few hours later the blue car’s brakes failed and it was wrapped around a telephone pole, the passenger side where Joan would have been sitting completely destroyed.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The other started innocently enough. My friend Linda stopped by to show off the crepe paper witch costume she planned to wear to a Halloween party that night, and the moment I opened the door I “saw” her and her costume engulfed in flames. I didn’t say a word—“Don’t let it catch fire” seemed like a pretty lame piece of advice—so I just made an appropriate fuss over how fabulous it was and laughed with her as she leapt and spun around the room practicing menacing witch behavior. But within minutes she whirled too close to the heating grate, and her skirt ignited. I don’t doubt for a moment that “seeing” it before it happened allowed me to help rather than panic, because I’d thrown her to the floor and rolled her up in an area rug before she even realized she was smoldering. She left the house shaken but unharmed and headed off to shop for a new less flammable costume.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("FTER SEVERAL MONTHS")])]), _vm._v(" of nasty, chaotic uncertainty, my parents reconciled. I was never quite sure how or why, or how much my desperate two-hour marriage stunt had to do with it, and I never asked. I was sure it didn’t involve candlelit dinners and violinists playing “Fascination” while Mother and Daddy gazed into each other’s eyes with renewed longing, so I settled for the sheer relief that it didn’t look as if there were going to be any logistical changes in my immediate future. We still bore no resemblance to the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Leave It to Beaver")]), _vm._v(" Cleaver family, but there was less fear, rage, and depression in the air now that words like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("divorce")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("alimony")]), _vm._v(", and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("custody")]), _vm._v(" had been removed from the equation.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To the best of my knowledge, that near-divorce convinced Daddy once and for all that dating while married was ultimately more trouble than it was worth. A lot of men would have caught on much sooner. But a lot of men weren’t married to Celeste.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I think I was about ten years old when I came home from school one day to find a big black sedan pulling away from the curb and Daddy, alone in the house, struggling to his feet just inside the front door, holding his bloody head that looked (probably accurately) as if it had come in violent contact with a heavy blunt instrument. He refused to tell me what had happened, or to call the police or his doctor, he simply kept assuring me that he was fine and it was nothing for me to worry about. But not long after that I was playing in the front yard when that same black sedan came speeding around the corner and screeched to a stop a few feet away from me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The driver, a hulking man with mean dark eyes, rolled down his window and gave me a message to pass along to Daddy: “Tell him I’m coming to get you if he doesn’t stay away from my wife.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I dutifully, and fearfully, delivered the message. Judging by Daddy’s reaction, being bashed in the head with a baseball bat was a trip to Disneyland compared to even a hint of some harm coming to me, and that was the end of whatever had gone on between him and Mrs. Black Sedan.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now, several years and girlfriends later, he’d faced the prospect of losing me again, along with Sharon and everyone and everything else he loved, and he’d decided it wasn’t worth it. If my mother happened to be part of that package, then, oh well, it was, all things considered, a small price to pay.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Such as it was, my family was intact again, and I felt as if I’d climbed back onto slightly more solid ground again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then the sky fell in.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WAS EIGHTEEN")])]), _vm._v(" and a freshman at St. Theresa’s College in Kansas City, majoring in education and literature with a minor in theology. I was exhilarated, inspired, and ready to conquer the world. The call from Daddy one deceptively normal morning telling me that Grandma Ada had been rushed to the hospital sent me into that numb, ear-ringing shock you never forget or quite recover from. She’d been diagnosed with a heart condition a few months earlier and had been warned that it was very serious, but through the magic of denial I’d convinced myself that the doctors were wrong and she’d be fine—this was my Grandma Ada, for God’s sake. Nothing was going to happen to her. She was indestructible. Besides, there was no one on earth I loved as much, no one I relied on or trusted more, no one I needed more to keep me grounded and hopeful and unafraid. I’d never spent a day of my life without her, and I couldn’t possibly start now, when everything around me was so new and unfamiliar.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She was in an oxygen tent, her eyes closed, when I walked into her room. Her face was utterly peaceful. Not a trace of pain or fear. I knew in the first instant of looking at her that she was joyfully going Home. I could barely breathe as I moved to her bed and selfishly whispered, “Please don’t go, Grandma. I love you so much.” She opened her eyes, just for a moment, and while she was much too weak to say a word, I heard her voice, strong and clear, promise, “I’ll send you a sign when I get there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I didn’t leave the hospital for the next three days while Mother, Daddy, and Sharon came and went, and I was alone with her when her body quietly gave out. I was sure my heart would break. It was insane to me that the rest of the world seemed to go right on with its trivial busy-ness as if it didn’t know or care that it had just been diminished.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page35"
    }
  }, [_vm._v("Francine chirped away to assure me that Grandma Ada had reached the Other Side in no time and enjoyed an ecstatic reunion ")]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("with countless loved ones who were waiting at the entrance to greet her. It was the first time I realized how selfish grief really is. I couldn’t separate from my own loss enough to be happy for her. And yes, I could see and hear the spirit world, but there was no way that seeing or hearing her could possibly take the place of her tangible presence. I hope I didn’t tell Francine to shut up, but I can honestly say I might have.")])]), _c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My boyfriend at the time, another Joe, picked me up first thing the next morning to take me for a quiet ride and help me escape the family gathering to plan the funeral. We drove in silence for mile after mile, going nowhere except away, both of us sadly aware that no matter how far we went, we couldn’t create enough distance between me and my pain to make a difference.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I barely heard him when, after an hour or so, he quietly said, “Uh…Sylvia…?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I glanced at him and saw that he was looking at something in his rearview mirror. “I don’t want to frighten you, but…your grandmother’s in the back seat.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I couldn’t bring myself to turn around. Instead, I stared straight ahead, and, very gradually, I began to sense her presence and detect the faint fragrance of her favorite lavender scent. Then I slowly let my eyes wander to the rearview mirror, and I gasped at the sight of Grandma Ada, in her favorite blue dress, peaceful, beaming with perfect health, eyes sparkling, smiling that smile of hers. I quickly turned to reach for her, but in the instant it took, she disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I know what you’re thinking. Despite the fact that I’d been seeing spirits for as long as I could remember, I clearly missed her and needed her so much that I just had one of those grief-induced hallucinations “experts” talk about at times like these.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page36"
    }
  }, [_vm._v("What made no sense to me then, and what makes no sense to me now: if that was a grief-induced hallucination, why was it Joe, who barely knew her and at most was simply sad for me, who saw her ")]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("first? And since he described her perfectly with no prompting from me when we talked about it later, we can also eliminate the possibility that he was only trying to comfort me by claiming to see her in the back seat of his car.")])]), _c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Call it a hunch, but there are times when I have a feeling the experts don’t know what they’re talking about.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("HERE WAS ANOTHER")])]), _vm._v(" aspect to Grandma Ada’s death that made it even more tragic. All her life she had deeply loved and taken care of her son, my uncle, whom we all called “Brother.” He was born with a birth defect that left him terribly crippled, an invalid with any number of challenges. Don’t ever let anyone convince you that the physically or mentally debilitated are being punished for some horrible past-life sin. Those who chart lives for themselves in which they face struggles many of us can only sympathize with are highly advanced spirits, and Brother was no exception. He was as sweet, dear, and brave a soul as I’ve ever met. In fact, when I was a child he almost lost his life saving mine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was playing in the front yard, completely absorbed in whatever shiny object had captured my attention, when I suddenly heard Brother’s voice yelling, “Run! Run!” from inside the house. I looked toward his voice and saw him struggling out the door toward me as fast as his body would allow, terrified and focused on something behind me. I turned around to face a huge, wild-eyed woman, her skin ghostly white, her hair flying, her fists clenched and waving around in a rage as she headed straight at me.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page37"
    }
  }, [_vm._v("Brother screamed, “Run, Sylvia!” again and managed to move himself between me and this oncoming madwoman, shielding me from her with his small, frail body and taking the full force of an assault that had been intended for me. The woman easily knocked him down and began violently beating him while I screamed at the top ")]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("of my lungs and tried to pull her away from him. Grandma Ada and two neighbors heard my screams and raced to Brother’s rescue. It took all of them to grab the woman and subdue her until the police arrived. She turned out to be the schizophrenic daughter of another neighbor and she lived at home under the dubious care of a full-time psychiatric nurse. It speaks volumes about Brother’s heart that despite the cuts and bruises he suffered in the attack, his only concern was comforting me and making sure I was okay.")])]), _c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So when Grandma Ada was in her final days in the hospital, we were all diligent about seeing to it that Brother knew he would always be taken care of and adored just as his mother adored him. Late one night I came home from the hospital after a day at Grandma Ada’s side and saw that the light was still on in Brother’s room. I sat down beside him on his bed. He opened his eyes and searched my face for some kind of hope about the woman we both loved so much. I didn’t have any to offer. What I did have, though, was Grandma Ada’s treasured crucifix. A nurse had given it to me that afternoon, explaining that my grandmother wanted me to have it. I put it in the palm of Brother’s transparent hand and closed his fingers around it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This should be yours,” I whispered to him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shook his head and simply said, “I don’t think I’ll need it now.” He put the crucifix back in my hand, and we cried together and recited the rosary.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When I came home from Grandma Ada’s memorial service a few days later, I went to Brother’s room to tell him all about it as I’d promised I would. I opened his door and walked toward his bed, managing a smile and saying, “Oh, Brother, she looked so beautiful….”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page38"
    }
  }, [_vm._v("That was as far as I got before Brother went into convulsions. He was rushed to the hospital and died two hours later. Left behind in his room were all his clothes and papers, perfectly organized in neat piles, the clothing carefully folded exactly as if he knew he was going home and had no intention of leaving a mess behind. The effort it ")]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_vm._v("must have taken him was unimaginable, but that loving, gentle soul wouldn’t have had it any other way. What an honor to have known him, and what great peace there finally was in the certainty that he and Grandma Ada were at Home and together again, exactly where they belonged.")])]), _c('a', {
    attrs: {
      "id": "page39"
    }
  }, [_c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("WO DAYS LATER")])]), _vm._v(" I was alone in my room, going through the motions of getting dressed, when I had the strongest feeling that someone was there with me. I glanced past my reflection in the dresser mirror and saw nothing but the closed bedroom door behind me. I turned and looked around. Still nothing. I focused on the mirror again, and now I was sure I felt a soft warm breath, just for an instant, passing across the back of my neck. I dismissed it as that word Grandma Ada always swore should be banished from the English language: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("imagination")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Two things happened almost simultaneously to prove me wrong: what sounded like a deafening clap of thunder filled the room as, crystal clear and unmistakable, Grandma Ada’s voice said, “Sylvia!” Less than a second later silence thickened the air, as if an electrical storm had just blown through.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My heart pounding with fear, I raced out my bedroom door to find Daddy running up the stairs toward me.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sylvia, what the hell happened?” he shouted. “What was that horrible cracking noise? It sounded like the roof collapsed. Are you all right? You’re white as a sheet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I was trembling, and he put his arm around me, walked me back into my room and sat down next to me on the bed as I described the previous two or three minutes. It surprised me to see him smiling.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What was it your grandmother promised you?” he reminded me. “Didn’t she say she’d send you a sign when she got Home? I think she just kept her promise.”")])]), _c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That deafening cracking noise, I learned later, was something called a “rapport,” and it’s not all that uncommon. Occasionally, when a spirit travels from the high-frequency dimension of the Other Side to our much lower frequency here on earth, it exceeds the speed of sound and creates shock waves, exactly the same sudden, intense buildups and releases of atmospheric pressure we experience as sonic booms. A rapport is simply the spirit world’s version of a sonic boom. They’ve been reported and studied for thousands of years. But for all the countless spirit visits I’ve received, the only rapport I’ve ever experienced was the one that Grandma Ada created in my bedroom that day to tell me she’d made it Home safely. Leave it to her to reassure me with a sign I couldn’t possibly miss.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("G"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("RANDMA")]), _vm._v(" A"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("DA HAD")])]), _vm._v(" insisted that someday I would be a teacher. Francine kept telling me that someday I would be a famous psychic and speak to large groups of people. It never occurred to me that those two predictions weren’t mutually exclusive, and I much preferred Grandma Ada’s. So I threw myself into my studies while also pursuing a very personal dream of my own, the most traditional, grounded, Norman Rockwell imagery you can imagine: a white picket fence surrounding a sweet little house, probably with bluebirds swooping down to trim my homemade pie crust, where I would spend my days as a school teacher and then hurry home to lovingly tend to my happy, handsome husband and darling children. I was determined to create a strong, secure, cohesive family and succeed where my parents had failed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Early proof that Francine’s right: none of us is allowed to read our own charts while we’re here on earth, which is why there’s not a psychic on earth, including me, who’s psychic about themselves.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page40"
    }
  }, [_vm._v("I had a lot of dates and a few serious boyfriends, none of them any more or less intense, heartbreaking, and ill conceived than ")]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_vm._v("yours probably were at that age. One wanted no part of this ridiculous psychic/Francine thing, or this nonsense about my going to college—I would hardly need a college education on the farm he dreamed of, raising our six children, for heaven’s sake. (Picture that.) Another I was so crazy about that I’m sure I would have married him in a heartbeat, until I found out, not from him, that he already had a wife and children back east. Still another I genuinely loved, and he was a wonderful man. But it became unavoidably apparent that there would have been three of us kneeling at our wedding altar: him, the grim disapproving woman beside him, and me in my white gown and veil robotically pledging, “I, Sylvia, take you and your mother….”")])]), _c('a', {
    attrs: {
      "id": "page41"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Agonizing as they seemed at the time, my relationship dramas paled in comparison to a crisis of the soul that had been building at school for several months. I’d become increasingly fascinated with the working of the human mind, and in addition to my required studies at St. Theresa’s I eagerly signed up for a course in abnormal psychology as well as an evening hypnosis class at the University of Kansas City. I found them both mesmerizing, but before long that abnormal psychology textbook started shaking me to my core as I read symptom after symptom of the deeply disturbed mind and realized that many of them described me much too closely for my own comfort.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seeing spirits and countless other images that no one else sees? You mean, that sign of various mental illnesses textbooks refer to as hallucinations?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hearing disembodied voices, like, oh, Francine, for example? Not uncommon in schizophrenia and other severe psychological afflictions.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Picking up depression, fear, paranoia, and every other negative emotion in the book from crowds of people around me? How did I know those disturbances were originating in other people? What made me think they weren’t all originating in me?")])]), _c('a', {
    attrs: {
      "id": "page42"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In other words, what if that three-hundred-year psychic family legacy Grandma Ada had taught me to cherish was actually a three-hundred-year family legacy of insanity?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The more I read, the more obvious it became: I wasn’t psychic at all. I was nuts. And most certainly too nuts to be allowed anywhere near children, let alone teach them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once I’d diagnosed myself beyond any reasonable doubt, I made an appointment for a consultation with Dr. John Renick, who was a psychiatrist and one of my most brilliant, most trusted professors.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I also said an official, sarcastic good-bye to the imaginary alter ego called Francine I’d been deluding myself with every day for the past twelve years. “She” didn’t argue, didn’t defend herself, didn’t even have the decency to get emotional. What she did do was ask me to allow her one indulgence before I permanently wrote her off as nothing more than a voice in my head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“One indulgence? Like what?” I asked, feeling ridiculous talking to her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ve never seen me,” she said. “I’ll appear for you tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I accepted the challenge, as much as the idea terrified me. At least when nothing happened, I would have all the sad proof I needed that my treasured friend, confidante, and Spirit Guide Francine never existed. I assembled my parents and sister for moral support and tried to ignore their excitement over the prospect of Francine materializing after all these years of my blathering about her. We could hear a night rain against the window as I dimmed the lights per Francine’s instructions (to protect her eyes on her first trip to this dimension since 1520, she said), and we settled in to wait.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We didn’t have to wait for long.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Almost imperceptibly the rocking chair beside me began to move, and the folds of a soft blue dress slowly took shape on the wood seat. Next came a hand with long, slender fingers, resting in the lap of the dress.")])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Daddy managed in an emotionally choked whisper, “Don’t anyone say a word. We don’t want to influence each other about what we’re seeing.” There was no danger of that. Except for the rain on the window, the silence in the room was almost palpable.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An arm the color of pale mocha formed above the hand, with a long black braid of hair resting against it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("That was all I could handle. I turned away and never glanced back, while my family, overwhelmed, kept on gaping. When they compared notes after it was over and Francine had disappeared, it was clear that they’d all seen exactly the same woman: tall, very thin, with perfect skin, huge dark doe eyes and high cheekbones, almost Egyptian looking and serenely beautiful. The whole experience of her, and of being in her presence, moved them to tears, while I couldn’t get away from them fast enough and without saying a word left them to their awe.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I told Dr. Renick the whole story at our first therapy session the next day, and he was surprised at my reaction. My family and I had seen absolute proof that Francine was real, and her being real meant that I wasn’t insane after all. He thought that would have been cause for celebration. “So why did you turn away from seeing her?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now it was my turn to cry as I blurted out, “Because I have to live in this world, Dr. Renick. I hear and see what normal people don’t, and I’m supposed to be grateful for that because it’s a gift from God. But I don’t want to be some freak, some goofy, airy-fairy weirdo. I just want to be a teacher. I just want to be normal. That’s all I want.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gave me the kindest, most compassionate smile and replied, “What a perfectly sane thing to say.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I still have the piece of paper on which he wrote his diagnosis: “Normal, but has paranormal abilities?” Even with the question mark, it meant the world to me, and from that day forward I never doubted my gifts or my sanity.")])])]), _c('a', {
    attrs: {
      "id": "page43"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page43"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00511d1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006chapter01.vue
// module id = 72
// module chunks = 0